const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const {
	ScreenWarning: ScreenWarningContent,
} = require("../util/components/ScreenWarning");
const AssetsUtil = require("../util/AssetsUtil");
const URLMake = require("../../../shared/URLMake");
const Link = require("./Link");
const withVaultDispatch = require("../hoc/withVaultDispatch");
const AT = require("../vault/ActionTypes");

const styles = require("./styles/ScreenWarning.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "ScreenWarning",

		propTypes: {
			isOffice: PT.bool,
			warning: PT.string.isRequired,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		ignoreWarning: function() {
			this.props.dispatch({type: AT.IGNORE_SCREEN_WARNING});
		},

		render: function() {
			const {isOffice, warning} = this.props;
			const message = <ScreenWarningContent warning={warning} />;
			let button;
			if (warning !== "rotate") {
				button = isOffice ? (
					<Link className={styles.button} to={URLMake.forBAOnline()}>
						Learn More
					</Link>
				) : (
					<div className={styles.button} onClick={this.ignoreWarning}>
						Close
					</div>
				);
			}

			const img =
				warning === "rotate"
					? AssetsUtil.getOfficeCharacter("headmaster-chalk")
					: AssetsUtil.getOfficeCharacter("headmaster-computer");

			return (
				<div className={styles.main}>
					<img className={styles.img} src={img} />
					<div className={styles.message}>
						{message}
						{button}
					</div>
				</div>
			);
		},
	})
);
